import { get } from 'lodash';

// Allows showing a placeholder component while loading something
// asynchronously. Will also check if loading failed with an HTTP error which
// allows the app to redirect to an error route.
export async function loadResourceWithPlaceholder(store, loadCallback) {
  let result;

  try {
    result = await loadCallback();
  } catch (error) {
    const httpError = get(error, 'response.data.errors[0]');

    if (!httpError) {
      throw error;
    }

    store.dispatch('setHttpError', httpError);

    return null;
  }

  return result;
}

// Same functionality as `loadResourceWithPlaceholder` except it must be used
// in the `beforeRouteEnter` hook.
export async function loadRoutableResourceWithPlaceholder(
  to,
  next,
  store,
  loadCallback
) {
  const result = await loadResourceWithPlaceholder(store, loadCallback);

  if (!result) {
    // See https://github.com/vuejs/vue-router/issues/977#issuecomment-304498068
    // TODO: This loses query params. Tried using `fullPath` instead but then it
    // encodes the `?` char. Investigate later.
    next({ name: 'httpError', params: [to.path] });
  }

  return result;
}
